/**
 * Market Data Service
 * Handles all market data-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get available trading symbols (public endpoint)
 * @returns {Promise}
 */
export const getSymbols = async () => {
  return apiGet(API_CONFIG.endpoints.symbols, {
    skipAuth: true, // Public endpoint, no auth required
  });
};

/**
 * Get current price for a specific symbol
 * @param {string} symbol - Trading symbol (e.g., 'EURUSD')
 * @returns {Promise}
 */
export const getSymbolPrice = async (symbol) => {
  return apiGet(API_CONFIG.endpoints.symbolPrice(symbol));
};

